
import blogPostQuery from "~/apollo/queries/blog/post";
import locomotiveScrollMixin from "@/mixins/locomotiveScrollMixin";
import previewModeMixin from "@/mixins/previewModeMixin";
import fetchPostMixin from "@/mixins/fetchPostMixin";
import {mdToHtml} from '~/utils/markdown'
import photoSwipeMixin from "@/mixins/photoSwipe";
import photoSwipeImgPathsMixin from "@/mixins/photoSwipeImgPaths";

export default {
  name: 'BlogPostSlug',
  colorMode: 'dark',
  mixins: [locomotiveScrollMixin, previewModeMixin, fetchPostMixin, photoSwipeMixin, photoSwipeImgPathsMixin],
  async asyncData({app, route, store}) {
    const previewMode = store.state.previewMode;

    if (previewMode) {
      await app.apolloProvider.defaultClient.resetStore();
    }

    // Fetch blogPost data
    const blogPostResponse = await app.apolloProvider.defaultClient.query({
      query: blogPostQuery,
      variables: {
        slug: route.params.slug,
        locale: app.i18n.locale,
      },
    });

    const blogPostData = blogPostResponse.data.blogPosts.data[0];

    // Process Markdown for each section
    blogPostData.attributes.sections = await mdToHtml(blogPostData);

    // Set route parameters for localization
    app.store.dispatch(
      "i18n/setRouteParams",
      Object.fromEntries(
        blogPostData.attributes.localizations.data.map((el) => [
          el.attributes.locale,
          {slug: el.attributes.slug},
        ])
      )
    );

    return {
      blogPost: blogPostData,
      previewMode
    }
  },
  computed: {
    imageAttributes() {
      if (this.blogPost
        && this.blogPost.attributes
        && this.blogPost.attributes.thumbnail
        && this.blogPost.attributes.thumbnail.data) {
        return this.getAttribute(this.blogPost.attributes.thumbnail.data, 'attributes');
      } else {
        return null;
      }
    },
  },
  data() {
    return {
      blogPost: null,
      galleryID: "#blog-gallery",
      photoSwipeActive: true,
    };
  },
  created() {
    const preview = this.$route.query.preview;

    if (preview) {
      // Set color as it doesn't automatically set after redirect
      this.$colorMode.preference = 'dark';

      if (!this.blogPost) {
        this.fetchPost('blogPosts', blogPostQuery).then(blogPostData => {
          this.blogPost = blogPostData;
          // ToDo add related posts logic
          // this.fetchRelatedPosts(blogPostData.attributes.tags.data.map(tag => tag.attributes.name)).then(relatedPostsData => {
          //   this.relatedPosts = relatedPostsData;
          //   this.$nextTick(() => {
          //     this.previewMode = true;
          //   });
          // });
          this.$nextTick(() => {
            this.previewMode = true;
          });
        });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    // Reset color as it doesn't automatically set after redirect (preview)
    this.$colorMode.preference = 'light';
    next()
  },
};
